import type { Provider, SavedRow } from "@/frontend/types/ehr-clients";
import type { EhrProviderTileState } from "@/frontend/types/dashboard/settings/ehr-providers";

/**
 * Derives a provider tile's display state under enabled-by-default semantics:
 * a coming-soon provider is non-clickable; an explicitly disabled row shows
 * "disabled"; otherwise the provider is enabled (custom creds if a client_id is
 * set, Medblocks creds when absent — including when no config row exists).
 */
export function getEhrProviderTileState(
  provider: Provider,
  savedRow: SavedRow | undefined,
): EhrProviderTileState {
  if ("comingSoon" in provider && provider.comingSoon === true) {
    return { variant: "coming-soon", clickable: false, subtitle: "Coming soon", badge: "coming-soon" };
  }
  if (savedRow?.disabled_at) {
    return { variant: "provider", clickable: true, subtitle: "Not connected", badge: "disabled" };
  }
  const subtitle = savedRow?.client_id ? "Custom credentials" : "Medblocks credentials";
  return { variant: "provider", clickable: true, subtitle, badge: "enabled" };
}
